<lib-alert-modal-content
    [cancelButtonLabel]="''"
    confirmButtonLabel="Try again"
    headerIcon="close"
    headerIconBackground="var(--ion-color-red-faded)"
    headerIconBackgroundColor="var(--ion-color-danger)"
    headerText="Sorry, we are unable to process your request"
>
    @if (errors.length === 1) {
        <p>{{ errors[0].message }}</p>
    } @else {
        <ion-list lines="none">
            @for (error of errors; track error.message; let index = $index) {
                <ion-item>
                    <ion-note slot="start">{{ index + 1 }}</ion-note>
                    <ion-label>{{ error.message }}</ion-label>
                </ion-item>
            }
        </ion-list>
    }
</lib-alert-modal-content>
